export default "__VITE_ASSET__ZoVeUD$K__"